import { Skeleton } from "@/components/ui/skeleton";
import { TableCell, TableRow } from "@/components/ui/table";

export interface DataTableSkeletonProps {
  rows?: number;
  columns: number;
}

/** Renders <rows> placeholder rows for the body of <DataTable> while loading. */
export function DataTableSkeleton({
  rows = 5,
  columns,
}: DataTableSkeletonProps) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <TableRow key={r}>
          {Array.from({ length: columns }).map((_, c) => (
            <TableCell key={c}>
              <Skeleton className="h-4 w-full max-w-[200px]" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
